var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWishIcon = function SvgWishIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m7.693 3.301.307.24.307-.24a3.76 3.76 0 0 1 2.318-.801c2.123 0 3.875 1.79 3.875 4.035 0 1.834-.847 3.379-2.129 4.708C11.148 12.51 9.553 13.555 8 14.428c-1.553-.873-3.147-1.917-4.371-3.185C2.347 9.913 1.5 8.369 1.5 6.535 1.5 4.289 3.252 2.5 5.375 2.5c.868 0 1.67.297 2.318.801Z"
  })));
};
export default SvgWishIcon;